const navbarNavigation= {};

navbarNavigation.init = () => {

    let navbarItemOpen = "active-menu-item";
    let $navbarItemLevel1 = document.querySelectorAll(".js-navbar-item-level-1");
    let $navbarItemBack = document.querySelectorAll(".js-navbar-item-back");

    for (let i=0;i<$navbarItemLevel1.length;i++) {
        $navbarItemLevel1[i].addEventListener("click",toggleMenuItem,false);
    }

    for (let i=0;i<$navbarItemBack.length;i++) {
        $navbarItemBack[i].addEventListener("click",closeMenuBack,false);
    }

    function toggleMenuItem(e){
        e.preventDefault();
        let $navbarItemOpen = document.querySelector("."+navbarItemOpen);
        let sameElem = false;
        if ($navbarItemOpen){
            closeMenuItem($navbarItemOpen);
            sameElem = $navbarItemOpen === e.target;
        }
        if (!sameElem){
            let panel = e.target;
            openMenuItem(panel);
        }
    }

    function closeMenuItem($navbarItemOpen){
        $navbarItemOpen.classList.remove(navbarItemOpen);
    }

    function openMenuItem(panel){
        panel.classList.add(navbarItemOpen);
    }

    function closeMenuBack(e){
        e.preventDefault();
        let $navbarItemOpen = document.querySelector("."+navbarItemOpen);
        $navbarItemOpen.classList.remove(navbarItemOpen);
    }

}

export default navbarNavigation;
